<template>
  <v-row v-touch="{left: () => swipe('Left'),right: () => swipe('Right')}">

    <v-navigation-drawer width="300" v-model="showFilterDrawer" app temporary right>
      <v-list-item>
        <v-btn class="mr-8" icon @click.stop="$store.commit('setShowFilterDrawer', false)">
          <v-icon>clear</v-icon>
        </v-btn>
        <v-list-item-content>
          <v-list-item-title>
            Filter Options
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>
      <v-list-item>
        <v-list-item-content>
          <v-text-field label="Name"
                        color="success"
                        v-model="nameFilter"
                        dense
                        clearable
                        hide-details
                        @input="resetPage"
                        @click:clear="resetPage"></v-text-field>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-text-field label="Card Number"
                        color="success"
                        v-model="cardNumberFilter"
                        dense
                        clearable
                        hide-details
                        @input="resetPage"
                        @click:clear="resetPage"></v-text-field>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-text-field label="Special Ability"
                        color="success"
                        v-model="specialAbilityFilter"
                        dense
                        clearable
                        hide-details
                        @input="resetPage"
                        @click:clear="resetPage"></v-text-field>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-text-field label="Identifier"
                        color="success"
                        v-model="identifierFilter"
                        dense
                        clearable
                        hide-details
                        @input="resetPage"
                        @click:clear="resetPage"></v-text-field>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-select label="Brigade"
                    color="success"
                    v-model="brigadeFilterList"
                    clearable
                    small-chips
                    disable-lookup
                    no-filter
                    hide-details
                    dense
                    multiple
                    @input="resetPage"
                    @click:clear="resetPage"
                    :items="brigadeList"></v-select>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-select label="Set"
                    color="success"
                    v-model="setFilterList"
                    clearable
                    small-chips
                    disable-lookup
                    no-filter
                    hide-details
                    dense
                    multiple
                    @input="resetPage"
                    @click:clear="resetPage"
                    :items="setList"></v-select>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-select label="Class"
                    color="success"
                    v-model="classFilterList"
                    clearable
                    small-chips
                    disable-lookup
                    no-filter
                    hide-details
                    dense
                    multiple
                    @input="resetPage"
                    @click:clear="resetPage"
                    :items="classList"></v-select>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-select label="Type"
                    color="success"
                    v-model="typeFilterList"
                    clearable
                    small-chips
                    disable-lookup
                    no-filter
                    hide-details
                    dense
                    multiple
                    @input="resetPage"
                    @click:clear="resetPage"
                    :items="typeList"></v-select>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-select label="Alignment"
                    color="success"
                    v-model="alignmentFilterList"
                    clearable
                    small-chips
                    disable-lookup
                    no-filter
                    hide-details
                    dense
                    multiple
                    @input="resetPage"
                    @click:clear="resetPage"
                    :items="alignmentList"></v-select>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-select label="Book"
                    color="success"
                    v-model="bookFilterList"
                    clearable
                    small-chips
                    disable-lookup
                    no-filter
                    hide-details
                    dense
                    multiple
                    @input="resetPage"
                    @click:clear="resetPage"
                    :items="bookList"></v-select>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-select label="Testament"
                    color="success"
                    clearable
                    small-chips
                    disable-lookup
                    no-filter
                    hide-details
                    dense
                    multiple
                    @input="resetPage"
                    @click:clear="resetPage"
          ></v-select>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-select label="Rarity"
                    color="success"
                    v-model="rarityFilterList"
                    clearable
                    small-chips
                    disable-lookup
                    no-filter
                    hide-details
                    dense
                    multiple
                    @input="resetPage"
                    @click:clear="resetPage"
                    :items="rarityList"></v-select>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-checkbox label="Star Ability"
                    color="success"
                    v-model="starAbilityFilter"
                    @input="resetPage"
                    @click:clear="resetPage"></v-checkbox>
      </v-list-item>

      <!--            <v-expansion-panels-->
      <!--                    multiple-->
      <!--                    class="px-3"-->
      <!--            >-->
      <!--                <v-expansion-panel>-->
      <!--                    <v-expansion-panel-header color="grey darken-3">Classes</v-expansion-panel-header>-->
      <!--                    <v-expansion-panel-content color="grey darken-3">-->
      <!--                        &lt;!&ndash;                                <v-list>&ndash;&gt;-->
      <!--                        &lt;!&ndash;                                    <v-list-item>&ndash;&gt;-->
      <!--                        &lt;!&ndash;                                        <v-list-item-content v-for="(item,i) in items" :key="i" >&ndash;&gt;-->
      <!--                        &lt;!&ndash;                                            <v-checkbox :label="item" hide-details dense ></v-checkbox>&ndash;&gt;-->
      <!--                        &lt;!&ndash;                                        </v-list-item-content>&ndash;&gt;-->
      <!--                        &lt;!&ndash;                                    </v-list-item>&ndash;&gt;-->
      <!--                        &lt;!&ndash;                                </v-list>&ndash;&gt;-->


      <!--                        <v-list-->
      <!--                                dense-->
      <!--                                flat-->
      <!--                        >-->
      <!--                            <v-list-item-group color="primary">-->
      <!--                                <v-list-item-->
      <!--                                        v-for="(item, i) in items"-->
      <!--                                        :key="i"-->
      <!--                                >-->
      <!--                                    <v-list-item-content>-->
      <!--                                        <v-checkbox :label="item" hide-details dense></v-checkbox>-->
      <!--                                    </v-list-item-content>-->
      <!--                                </v-list-item>-->
      <!--                            </v-list-item-group>-->
      <!--                        </v-list>-->

      <!--                    </v-expansion-panel-content>-->
      <!--                </v-expansion-panel>-->
      <!--            </v-expansion-panels>-->

      <v-list-item>
        <!--                <v-list-item-content>-->
        <!--                    <v-btn color="success" @click="resetPage">Update Filter</v-btn>-->
        <!--                </v-list-item-content>-->
      </v-list-item>

      <v-list>

      </v-list>
    </v-navigation-drawer>


    <v-col cols="12" fill-height>

      <!--            <v-btn @click="test"></v-btn>-->
      <p class="unselectable" align="right" style="opacity: 25%;">search filter in upper right corner</p>
      <v-pagination
          v-model="pagination.page"
          :length="numPages"
          :total-visible="pagination.length"
          circle
          @input="$vuetify.goTo(0)"
      ></v-pagination>
      <v-row justify="center">
        <card-tile class="ma-3 pa-2" v-for="(card, index) in visibleCards" :key="index" :card-data="card"></card-tile>
      </v-row>
      <v-pagination
          v-model="pagination.page"
          :length="numPages"
          :total-visible="pagination.length"
          circle
          @input="$vuetify.goTo(0)"
      ></v-pagination>
    </v-col>

  </v-row>
</template>

<style>

.unselectable {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

</style>

<script>
import {mapFields} from 'vuex-map-fields';

export default {
  name: "Cards",
  data() {
    return {
      swipeDirection: 'None',
      pagination: {
        page: 1,
        length: 7,
      },
    };
  },
  beforeMount() {

  },
  methods: {
    resetPage() {
      this.pagination.page = 1;
    },
    swipe(direction) {
      this.swipeDirection = direction;
      console.log(direction);
      if (direction === "Right") {
        if (this.pagination.page > 1) {
          this.$vuetify.goTo(0);
          this.pagination.page--;
        }
      } else if (direction === "Left") {
        if (this.pagination.page < this.numPages) {
          this.$vuetify.goTo(0);
          this.pagination.page++;
        }
      }
      this.swipeDirection = "None";
    },
    // test() {
    //     console.log(this.setList);
    // }
  },
  computed: {
    ...mapFields([
      "filterValues.starAbilityFilter",
      "filterValues.nameFilter",
      "filterValues.cardNumberFilter",
      "filterValues.specialAbilityFilter",
      "filterValues.identifierFilter",
      "filterValues.setFilterList",
      "filterValues.alignmentFilterList",
      "filterValues.bookFilterList",
      "filterValues.brigadeFilterList",
      "filterValues.classFilterList",
      "filterValues.rarityFilterList",
      "filterValues.typeFilterList",
    ]),

    showFilterDrawer: {
      get() {
        return this.$store.getters.getShowFilterDrawer;
      },
      set(value) {
        this.$store.commit('setShowFilterDrawer', value);
      },
    },

    setList() {
      return this.$store.getters.getSetList;
    },
    alignmentList() {
      return this.$store.getters.getAlignmentList;
    },
    bookList() {
      return this.$store.getters.getBookList;
    },
    brigadeList() {
      return this.$store.getters.getBrigadeList;
    },
    classList() {
      return this.$store.getters.getClassList;
    },
    rarityList() {
      return this.$store.getters.getRarityList;
    },
    typeList() {
      return this.$store.getters.getTypeList;
    },
    numPages() {
      const length = this.filteredCards.length;
      return length > 0 ? Math.ceil(length / this.cardsPerPage) : 0;
    },
    cardsPerPage() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 10;
        case 'sm':
          return 10;
        case 'md':
          return 30;
        case 'lg':
          return 30;
        case 'xl':
          return 50;
      }
      return 10;
    },
    filteredCards() {
      return this.$store.getters.getFilteredCards;
    },
    visibleCards() {
      return this.filteredCards.slice((this.pagination.page - 1) * this.cardsPerPage, this.pagination.page * this.cardsPerPage);
    },
  },
  watch: {
    filteredCards() {
      this.pagination.page = 1;
    }
  },
  created() {

  }
}
</script>

<style scoped>

</style>
